import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import InputTextField from '../../../components/input/inputTextField';
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView, dateToView, timeToView } from '../../../utils/date.utils';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import { useDispatch } from 'react-redux';
import ModalCustom from '../../../components/modal/ModalCustom';
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { MeetingTypeApi } from '../../../api/meeting-type/meeting-type.api';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { ThesisCategoryApi } from '../../../api/thesis-category/thesis-category.api';
import { ThesisTypeApi } from '../../../api/thesis-type/thesis-type.api';
import { ReportApi } from '../../../api/report/Report.api';
import { LogUserApi } from '../../../api/log-user/log-user.api';

const defaultState = {
    id_thesis_type: 0,
    thesis_type_name: undefined,
}
export default function EThesisHistory() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");

    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '80px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: "ลำดับ",
        },
        {
            id: "#",
            width: '150px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: "วันที่",
        },
        {
            id: "#",
            width: '150px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: "เวลา",
        },
        {
            id: "leave_type_name",
            width: '300px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อวิทยานิพนธ์"),
        },
        {
            id: "#",
            width: '300px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: "ชื่อผู้ใช้",
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("รายละเอียดของการกระทำ"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("IP Address"),
        },
        // {
        //     id: "action",
        //     disablePadding: false,
        //     align: "center",
        //     width: '100px',
        //     label: "action",
        // },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_thesis_type, log_date, buddhist_name, full_name, log_event, modified_date } =
            objData;

        const objRenderData = {
            key: id_thesis_type,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(log_date) || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: timeToView(log_date) || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: buddhist_name,
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: full_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: log_event || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: '',
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await LogUserApi.getThesisBookList(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit,search]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleDownload = async () => {
        let condition: any = {};
        if (page) condition = { ...condition, page: page };
        if (pageLimit) condition = { ...condition, limit: pageLimit };
        if (search) condition = { ...condition, keyword: search };
        await ReportApi.logThesis(condition).then((res: any) => {
            if (res.status < 300) {
                // window.open(process.env.REACT_APP_FILE_BASE_API + '/' + file?.file_path + file?.file_name, '_blank');
                const blobFile = new Blob([res?.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const url = URL.createObjectURL(blobFile);
                window.open(url, '_blank');

                console.log(res.data);
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    return (
        <div>
            <ContentHeading
                title={t("ประวัติการเข้าชมวิทยานิพนธ์")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา ชื่อวิทยานิพนธ์ ชื่อผู้ใช้ IP Address")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.ManageLeaveType + `/create`);
                            // setOpen(true)
                            // setType('CREATE')
                            handleDownload()
                        }}
                        mode="add"
                        buttonName={t("ดาวน์โหลด Excel")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>

        </div>
    )
}
